export default "__VITE_ASSET__B2trCdu6__"